import React from 'react';
import PropTypes from 'prop-types';
import { Title } from "../../Typography/index";

const CheckmarkIcon = () => (
  <svg className="icon-checkmark" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="10" fill="#F50A23" />
    <path d="M9 12l2 2 4-4" stroke="#fff" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const LoaderStep = ({ icon, text, className }) => (
    <div className={`loader-step ${className}`}>
      <div className="loader-step-icon">
        <div className="icon-gray">{icon}</div>
        <CheckmarkIcon />
      </div>
      <div className="loader-step-text">
        <Title size="small">{text}</Title>
      </div>
    </div>
  );

LoaderStep.propTypes = {
  icon: PropTypes.node.isRequired,
  text: PropTypes.string.isRequired,
  className: PropTypes.string,
};

LoaderStep.defaultProps = {
  className: '',
};

export default LoaderStep;
